import React from 'react';
import dp from '../../images/faisal.jpg';
import style from './About.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const About = () => {

  document.addEventListener('mousemove', e=> {

    let bubles = document.createElement('bubles');
    let x = e.pageX;
    let y = e.pageY;
    bubles.style.left = x + "px";
    bubles.style.top = y + "px";
    let size = Math.random() * 10;
    bubles.style.width = 1 + size + "px";
    bubles.style.height = 1 + size + "px";
    
    document.body.appendChild(bubles);
    setTimeout(function() {
      bubles.remove();
    }, 1100);
  });


  return (
    <div className={style.about} id="about">
      <div className="container">
        <div className="text-center">
          <h1>About Me</h1>
        </div>
        <div className="mt-3 row aboutInside">
          <div className="col-lg-5 col-12 my-4">
            <div className="d-flex justify-content-center align-items-center">
              <div className={style.dp}>
                <img src={dp} className='img-fluid' alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-12 my-4">
            <div className={style.aboutMe}>
              <p> I am Faisal Ahmed, A tech enthusiast and love to learn and explore web technologies. I have completed my Bsc. degree in computer science and engineering at City University in 2020. I am a junior web developer. Currently, I am exploring React js, Node, MongoDb and React native also. </p>
              <a href="https://drive.google.com/uc?export=download&id=1UCq439skdDlagvhn97_HtCehHB2skDck" type='button' className='btn btn-custom mt-3' rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faDownload} /> Resume</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;